import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/headless/examples/grouped-message-timeline/grouped-message-timeline.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
